import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'black';
  icon?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  icon = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3 rounded-full font-medium transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-[#FFC4D0] text-black hover:bg-white border-2 border-transparent',
    outline: 'bg-transparent border-2 border-black text-black hover:bg-black hover:text-white',
    black: 'bg-black text-white hover:bg-gray-800 border-2 border-transparent'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-200">
      {children}
      {icon && <ArrowRight className="ml-2 h-4 w-4" data-id="element-201" />}
    </button>;
}